import jwtAuthAxios from "./auth/jwtAuth";

const releaseNoteServices = {};

// `index` devuelve { data: [...] }. Sin paginación a propósito: son pocas tandas y se leen
// todas juntas. `include_drafts` solo tiene efecto para un superadmin.
releaseNoteServices.getReleaseNotes = async (params = "") => {
    const { data } = await jwtAuthAxios.get(`/release_notes${params}`);
    return data;
};

// Con un PDF adjunto la tanda viaja como multipart; sin archivo, como siempre en JSON.
const toFormData = (payload) => {
    const form = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
        if (value === undefined || value === null) return;
        if (Array.isArray(value)) {
            value.forEach((item) => form.append(`release_note[${key}][]`, item));
        } else {
            form.append(`release_note[${key}]`, value);
        }
    });
    return form;
};

const sendReleaseNote = (method, url, payload) => {
    if (Object.values(payload).some((value) => value instanceof File)) {
        return jwtAuthAxios[method](url, toFormData(payload), {
            headers: { "Content-Type": "multipart/form-data" },
        });
    }
    return jwtAuthAxios[method](url, { release_note: payload });
};

// create, update, publish y unpublish devuelven la tanda plana, sin root.
releaseNoteServices.createReleaseNote = async (payload) => {
    const { data } = await sendReleaseNote("post", `/release_notes`, payload);
    return data;
};

releaseNoteServices.updateReleaseNote = async (id, payload) => {
    const { data } = await sendReleaseNote("patch", `/release_notes/${id}`, payload);
    return data;
};

// El PDF no viene en la lista: se pide al abrirlo y llega un link que vence en minutos.
releaseNoteServices.getDocumentUrl = async (id) => {
    const { data } = await jwtAuthAxios.get(`/release_notes/${id}/document`);
    return data;
};

// Lo mismo para el video subido.
releaseNoteServices.getVideoUrl = async (id) => {
    const { data } = await jwtAuthAxios.get(`/release_notes/${id}/video`);
    return data;
};

releaseNoteServices.publishReleaseNote = async (id) => {
    const { data } = await jwtAuthAxios.post(`/release_notes/${id}/publish`);
    return data;
};

releaseNoteServices.unpublishReleaseNote = async (id) => {
    const { data } = await jwtAuthAxios.post(`/release_notes/${id}/unpublish`);
    return data;
};

releaseNoteServices.deleteReleaseNote = async (id) => {
    const { data } = await jwtAuthAxios.delete(`/release_notes/${id}`);
    return data;
};

export default releaseNoteServices;
